import moment from 'moment'
import { parseRelativeDate } from './relativeDateParser.js'

const extractTime = /(?:^|\s+(?:at|@)\s+|\s)((1[0-2]|0?[1-9])(:?[0-5][0-9])?\s?(AM|PM))\s*$/i
const commonDateFormats = [moment.ISO_8601, 'MMMM D, YYYY', 'MMMM D YYYY', 'MMMM D YY', 'MMM D YYYY', 'MMM D YY', 'D MMMM YYYY', 'D MMM YYYY', 'D MMMM YY', 'D MMM YY', 'MMMM D', 'D MMMM', 'MMM D', 'D MMM']
const usDateFormats = [...commonDateFormats, 'MM/DD/YYYY', 'MM/DD/YY', 'MM DD YY', 'MM DD YYYY', 'MM/DD', 'MM DD']
const euDateFormats = [...commonDateFormats, 'DD/MM/YYYY', 'DD/MM/YY', 'DD MM YY', 'DD MM YYYY', 'DD/MM', 'DD MM']

export const dateParser = (input = '', dayMonthOrder = 'us') => {
  let parsedDate
  let firstPart = input
  let timePart

  const timeMatch = input.match(extractTime)
  if (timeMatch) {
    timePart = timeMatch[1]
    firstPart = input.slice(0, input.length - timeMatch[0].length)
  }
  const res = parseRelativeDate(firstPart)
  const datePart = res ? firstPart.slice(0, res.idx) : firstPart
  if (datePart) {
    parsedDate = moment(datePart, dayMonthOrder === 'us' ? usDateFormats : euDateFormats, true)
  } else {
    parsedDate = moment({ hour: 0,  minute: 0, second: 0, millisecond: 0})
  }
  if (timePart) {
    let parsedTime = moment(timePart, ['hh:mm a', 'hhmma', 'hh a'])
    if (parsedDate) {
      parsedDate = parsedTime.year(parsedDate.year()).month(parsedDate.month()).date(parsedDate.date())
    }
  }
  if (res) {
    if (res.startOffset) { parsedDate = parsedDate.add(...res.startOffset) }
    if (res.startDayOfWeek) { parsedDate = parsedDate.day(res.startDayOfWeek) }
    if (res.offset) { parsedDate = parsedDate.add(...res.offset) }
  }
  return parsedDate
}